export default "__VITE_ASSET__Bxpj8scy__"